import React, { Component, Fragment } from 'react'


import DemoForm from '../../components/site/Forms/DemoForm'
import Picture from '../../components/Picture'

class NewMainBanner extends Component {
    static defaultProps = {
        title: 'Automatize seus pedidos e controle suas vendas',
        description: 'Com o sistema de automação de vendas e e-commerce B2B da Mercos, você organiza os seus processos de vendas, economiza tempo e evita erros integrando tudo ao seu ERP.',
        imgSrc: '/images/site/new-home/banner-img.png',
        imgAlt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
        imgMobileSrc: '/images/site/new-home/banner-img-mobile.png',
        buttonShadow: false,
    }

    render() {
        const { title, description, imgSrc, imgAlt, imgMobileSrc, buttonShadow } = this.props;

        return (
            <Fragment>
                <div className={`new-main-banner-v2 new-hero new-hero-purple-bg ${this.props.title ? 'new-main-banner-v3' : ''}`}>
                    <div className='container'>
                        <div className="column first-col">
                            <div className='title-hero'>
                                <h1 className='title'>{title}</h1>
                            </div>
                            <div className='main-subheading-container'>
                                <h2 className='description'>{description}</h2>
                            </div>
                            <DemoForm darkBg showOr trialAndDemo="comece grátis" modalLink buttonShadow={buttonShadow} />
                        </div>
                        <div className="column">
                            <Picture
                                className='hero-img-full-right'
                                src={imgSrc}
                                alt={imgAlt}
                                mobileSrc={imgMobileSrc}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default NewMainBanner



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewMainBanner/NewMainBannerv3.jsx